var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contest"},[_vm._v("比赛")])
}
var staticRenderFns = []

export { render, staticRenderFns }